module.exports = __webpack_public_path__ + "img/tbank.5c095751.svg";